"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeRequestMethod = void 0;
const axios_1 = __importDefault(require("axios"));
const types_1 = require("./types");
const getNestedProperty = (obj, path) => {
    // eslint-disable-next-line @typescript-eslint/prefer-optional-chain, @typescript-eslint/no-explicit-any
    return path.split('.').reduce((acc, part) => acc && acc[part], obj);
};
const makeRequestMethod = (client) => {
    return async (methodPath, params) => {
        const method = getNestedProperty(client, methodPath);
        if (!method) {
            throw new Error(`The method ${methodPath} does not exist`);
        }
        try {
            const data = await method(params);
            return { success: true, data };
        }
        catch (error) {
            // @ts-expect-error ts doesn't know how to interpret isError existing as a property on a function
            if (method.isError?.(error)) {
                const endpointError = error;
                return {
                    success: false,
                    errorType: 'olympus',
                    error: endpointError,
                    message: endpointError.message,
                };
            }
            if (axios_1.default.isAxiosError(error)) {
                return {
                    success: false,
                    errorType: 'axios',
                    error,
                    message: (0, types_1.isErrorWithMessage)(error.response?.data)
                        ? error.response.data.message
                        : undefined,
                };
            }
            return {
                success: false,
                errorType: 'unknown',
                error,
                message: error?.message,
            };
        }
    };
};
exports.makeRequestMethod = makeRequestMethod;
//# sourceMappingURL=makeRequestMethod.js.map